<template>
    <div>
        <Divider style="margin:0 0 10px 0" />
        <Row class="m-t-5 m-b-5">
            <i-col span="3">
                <span class="search-label"> {{currentCityCode?'对比线路':'当前城市'}}</span>
            </i-col>
            <i-col span="21">
            <div
                v-for="item in searchResultGroup"
                :key="'res_city_'+item.id"
                class="search-res-city"
            >
                <div
                :class="chooseResultGroup===item.id?'search-res-city-actived':''"
                class="m-r-5"
                >
                <span
                    style="padding-right:3px;"
                    @click="handleChangeResultGroup(item.id)"
                >{{item.name}}({{item.quantity}})</span>
                <a @click="handleRemoveResultGroup(item.id)">
                    <Icon
                    size="18"
                    type="ios-close"
                    ></Icon>
                </a>
                </div>
            </div>
            </i-col>
        </Row>

        <Table id="station_table"
            :loading="loading"
            stripe
            :columns="searchColumns"
            :data="searchTableData"
            @on-sort-change="handleTableSort"
        ></Table>
        <div class="m-t-10">
            <Page
            :current="pageParams.pageNumber"
            :total="resultTotalRow"
            :page-size="pageParams.pageSize"
            @on-change="handlePageChange"
            show-total
            />
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { toMoneyNoPrefix, toNumber } from '@/utils/wnumb_own'
import { getCurrentCity } from '@/api/search'

export default {
  data () {
    return {
      loading: false,
      currentUserCity: null,
      searchColumns: [],
      searchTableData: [],
      resultTotalRow: 0,

      pageParams: {
        totalRow: 0, // 总行数
        pageNumber: 1,
        pageSize: 10
      },
      searchResultGroup: [], // 需要显示的查询结果
      chooseResultGroup: '' // 查询结果选中组的默认值
    }
  },
  methods: {
    dynamicTableColumn () {
      this.searchColumns = [
        {
          title: '站名',
          width: 125,
          render: (h, params) => {
            let showLabel = h('div', { style: { 'display': 'inline' } }, [
              h('Icon', {
                props: { size: 18 },
                attrs: {
                  class: 'ivu-icon ivu-icon-ios-pin-outline search-icon-color'
                },
                style: { 'cursor': 'pointer' },
                on: {
                  click: () => {
                    this.$store.commit('set_search_chooseStation', params.row)
                    this.$router.push({ name: 'search-station' })
                  }
                }
              }),
              h('span', params.row.stationName)
            ])
            let showTab = h('div', { style: { 'display': 'inline', top: '-5px', position: 'relative' } },
              params.row.companyId > 0 ? [h('span', { attrs: { class: 'search-list-hot' } }, 'Hot')] : '')

            return h('div', [showLabel, showTab])
          }
        },
        // {
        //   title: '运营商',
        //   width: 125,
        //   render: (h, params) => {
        //     let showLabel = h('div', { style: { 'display': 'inline' } }, [
        //       h('Icon', {
        //         props: { size: 18 },
        //         attrs: {
        //           class: 'ivu-icon ivu-icon-ios-call-outline search-icon-color'
        //         },
        //         style: { 'cursor': 'pointer' },
        //         on: {
        //           click: () => {
        //             this.$store.commit('set_search_chooseStation', params.row)
        //             this.$router.push({ name: 'search-station' })
        //           }
        //         }
        //       }),
        //       h('span', '营运商名称')
        //     ])

        //     return h('div', [showLabel])
        //   }
        // },
        {
          title: '线路',
          width: 110,
          key: 'assetName',
          render: (h, params) => {
            let assetName = params.row.assetName

            return h('span', this.currentCityCode ? assetName.substr(assetName.indexOf('铁') + 1) : assetName)
          }
        },
        {
          title: '关键字',
          key: 'number',
          width: 110,
          sortable: 'custom',
          render: (h, params) => {
            let showLabel = []
            if (params.row.keyNumber && params.row.keyNumber.length > 0) {
              params.row.keyNumber.forEach(element => {
                showLabel.push(h('span', element.name + '(' + element.number + ')'))
                showLabel.push(h('br'))
              })
            } else {
              showLabel.push(h('span', '-'))
            }

            return h('div', showLabel)
          }
        }
      ]

      if (this.currentCheckDimension.includes('11')) {
        this.searchColumns.push({
          title: '品牌',
          key: 'interBrand',
          width: 110,
          sortable: 'custom',
          render: (h, params) => {
            return h('div', [
              h('span', '国际 (' + params.row.interBrand + '个)'),
              h('br'),
              h('span', '国内 (' + params.row.domesticBrand + '个)')
            ])
          }
        })
      }
      if (this.currentCheckDimension.includes('12')) {
        this.searchColumns.push(
          {
            title: '房价(元)',
            key: 'housePrice',
            sortable: 'custom',
            align: 'center',
            width: 110,
            render: (h, params) => {
              return h('span', params.row.housePrice === 0 ? '-' : toMoneyNoPrefix(params.row.housePrice))
            }
          }
        )
      }
      if (this.currentCheckDimension.includes('13')) {
        this.searchColumns.push(
          {
            title: '客单价(元)',
            key: 'consumePrice',
            sortable: 'custom',
            align: 'center',
            width: 120,
            render: (h, params) => {
              return h('span', params.row.consumePrice === 0 ? '-' : toMoneyNoPrefix(params.row.consumePrice))
            }
          }
        )
      }

      if (this.currentCheckDimension.includes('21')) {
        this.searchColumns.push(
          {
            title: '换乘',
            key: 'transferNumber',
            sortable: 'custom',
            align: 'center',
            width: 100,
            render: (h, params) => {
              return h('span', params.row.transferNumber)
            }
          }
        )
      }
      if (this.currentCheckDimension.includes('22')) {
        this.searchColumns.push({
          title: '公交',
          key: 'busAsset',
          width: 130,
          sortable: 'custom',
          render: (h, params) => {
            return h('div', [
              h('span', '公交线路数(' + params.row.busAsset + '条)'),
              h('br'),
              h('span', '公交站点数(' + params.row.busStation + '个)')
            ])
          }
        })
      }
      if (this.currentCheckDimension.includes('23')) {
        this.searchColumns.push(
          {
            title: '通达数',
            key: 'exitNumber',
            sortable: 'custom',
            align: 'center',
            width: 80,
            render: (h, params) => {
              return h('span', params.row.exitNumber === 0 ? '-' : params.row.exitNumber)
            }
          }
        )
      }

      if (this.currentCheckDimension.includes('31')) {
        this.searchColumns.push(
          {
            title: '进出站月客流',
            key: 'flowNumber',
            width: 110,
            align: 'center',
            sortable: 'custom',
            render: (h, params) => {
              return h('span', params.row.flowNumber === 0 ? '-' : toNumber(params.row.flowNumber))
            }
          }
        )
      }
      this.searchColumns.push({
        title: this.comprehensiveRating ? '级别' : '相关度',
        key: 'rank',
        sortable: 'custom',
        width: 80,
        align: 'center',
        render: (h, params) => {
          return h('span', params.row.rank + (this.comprehensiveRating ? '级' : '%'))
        }
      })

      // 根据配置显示关注列
      if (!this.companySetting || this.companySetting.openFollow) {
        this.searchColumns.push(
          {
            fixed: 'right',
            align: 'center',
            width: 70,
            renderHeader: (h, obj) => {
              if (this.purchaseList.length > 0) {
                return h('a', {
                  attrs: { class: 'search-icon-color' },
                  on: {
                    click: () => {
                      this.$store.commit('set_search_showPurchase', new Date())
                    }
                  }
                }, '已关注(' + this.purchaseList.length + ')')
              } else {
                return h('span', '关注')
              }
            },
            render: (h, params) => {
              if (this.purchaseList.find(x => x.stationId === params.row.stationId)) {
                return h('Icon', {
                  props: { type: 'md-checkmark-circle-outline', size: 18, color: '#19be6b' },
                  style: { 'cursor': 'pointer' },
                  on: {
                    click: (event) => {
                      this.handleRemovePurchase(params.row)
                    }
                  }
                })
              } else {
                return h('Icon', {
                  props: { type: 'md-add', size: 22 },
                  style: { 'cursor': 'pointer' },
                  on: {
                    click: (event) => {
                      this.handlePurchaseStation(params.row)
                    }
                  }
                })
              }
            }
          }
        )
      }
    },
    sortCurrentUserCity () { // 排序所有的城市分组集合
      let sortResult = this.searchResultGroup.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
      let currentUserCityResult = sortResult.find(x => x.id === this.currentUserCity.code)
      if (currentUserCityResult) {
        sortResult.splice(sortResult.findIndex(x => x.id === this.currentUserCity.code), 1)
        sortResult.splice(0, 0, currentUserCityResult)
        this.searchResultGroup = sortResult

        this.handleChangeResultGroup(currentUserCityResult.id)
      } else {
        this.searchResultGroup = sortResult
        this.handleChangeResultGroup()
      }
    },
    handleTableSort (params) {
      this.defaultSearchCondition.pageNumber = 1
      if (params.order === 'normal') { // 取消排序
        this.defaultSearchCondition.orderByStr = 'number'
        this.defaultSearchCondition.orderByType = null
      } else {
        this.defaultSearchCondition.orderByStr = params.key
        this.defaultSearchCondition.orderByType = params.order === 'asc' ? 1 : 0
      }
      this.loadSearchResult()
    },
    handlePurchaseStation (item) { // 加入关注
      let updateBean = {
        type: 'add',
        item: item
      }
      this.$store.commit('set_search_updatePurchase', updateBean)
    },
    handleRemovePurchase (item) { // 移除选中
      let updateBean = {
        type: 'remove',
        item: item
      }

      this.$store.commit('set_search_updatePurchase', updateBean)
    },
    handleChangeResultGroup (groupId) {
      let searchCityCodes = []
      if (this.chooseResultGroup === groupId || !groupId) {
        this.chooseResultGroup = ''
        searchCityCodes = this.searchResultGroup.map(x => x.id)
      } else {
        this.chooseResultGroup = groupId
        searchCityCodes = [groupId]
      }

      this.defaultSearchCondition.pageNumber = 1
      this.defaultSearchCondition.cityCodes = searchCityCodes
      this.loadSearchResult()
    },
    handleRemoveResultGroup (groupId) { // 查询结果中移除选择的分组ID
      this.defaultSearchCondition.pageNumber = 1
      this.searchResultGroup = this.searchResultGroup.filter(x => x.id !== groupId)
      if (this.chooseResultGroup === '' || this.chooseResultGroup === groupId) { // 未选择或者已被选中
        this.chooseResultGroup = ''
      }

      this.defaultSearchCondition.cityCodes = this.searchResultGroup.map(x => x.id)
      this.loadSearchResult()
    },
    handleSearch () {
      if (this.defaultSearchCondition.keywords === '') {
        this.originalSearchResult = []
        this.groupSearchResult()
      } else {
        this.loading = true
        axios.post(process.env.API_URL + '/ooh-search/v1/search/getcityquantity',
          this.defaultSearchCondition,
          {
            headers: {
              'Content-Type': 'application/json'
            },
            withCredentials: false
          }
        ).then(res => {
          this.dynamicTableColumn()
          this.formatGroupSearchResult(res.data)
        }).catch(() => {
          this.loading = false
        })
      }
    },
    formatGroupSearchResult (cityGroup) {
      this.searchResultGroup = cityGroup.map(x => {
        return {
          id: x.cityCode,
          name: x.cityName,
          quantity: x.quantity
        }
      })

      if (this.currentCityCode) { // 反选线路
        this.searchResultGroup = this.searchResultGroup.sort((a, b) => {
          return a.orderby - b.orderby
        })
      } else { // 2C版本需要默认选中用户所在城市
        if (!this.currentUserCity) {
          getCurrentCity().then(res => {
            this.currentUserCity = res
            this.sortCurrentUserCity()
          })
        } else {
          this.sortCurrentUserCity()
        }
      }
    },
    loadSearchResult () {
      axios.post(process.env.API_URL + '/ooh-search/v1/search/getsearchresultpage',
        this.defaultSearchCondition,
        {
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: false
        }
      ).then(res => {
        this.resultTotalRow = res.data.totalRow
        this.searchTableData = res.data.list
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handlePageChange (page) {
      this.defaultSearchCondition.pageNumber = page
      this.loadSearchResult()
    }
  },
  computed: {
    companySetting () {
      return this.$store.state.user.companySetting
    },
    beginSearch () {
      return this.$store.state.search.beginSearch
    },
    defaultSearchCondition () {
      return this.$store.state.search.searchCondition
    },
    purchaseList () {
      return this.$store.state.search.purchaseList
    },
    currentCheckDimension () {
      let checkDimension = this.$store.state.search.searchCondition.indexes

      return checkDimension.map(x => x.index)
    },
    filterData () {
      return this.$store.state.search.filterData
    },
    currentCityCode () {
      return this.companySetting ? this.companySetting.citys[0] : null
    },
    comprehensiveRating () { // 综合定级
      return this.companySetting ? this.companySetting.comprehensiveRating : null
    }
  },
  watch: {
    beginSearch (val) {
      if (val) {
        this.handleSearch()
      }
    },
    filterData () {
      // this.handleChangeResultGroup(this.chooseResultGroup, false)
    }
  }
}
</script>
